import { useEffect } from "react";

const CLIENT_IDS = {
  "agendalink.app": process.env.NEXT_PUBLIC_PDF_KEY_LEGACY,
  "justmeetings.com": process.env.NEXT_PUBLIC_PDF_KEY,
  localhost: process.env.NEXT_PUBLIC_PDF_KEY_LOCAL,
};

const getClientId = () => {
  const host = window.location.hostname;
  return CLIENT_IDS[host] ?? CLIENT_IDS[host.split(".").slice(-2).join(".")];
};

const AdobeViewer = ({ url, fileName, pageNumber = 1 }) => {
  useEffect(() => {
    if (url) {
      const initializeAdobeSDK = () => {
        const adobeDCView = new AdobeDC.View({
          // clientId: process.env.NEXT_PUBLIC_PDF_KEY,
          clientId: getClientId(),
          divId: "adobe-dc-view",
        });

        const previewFilePromise = adobeDCView.previewFile(
          {
            content: { location: { url } },
            metaData: { fileName },
          },
          { showAnnotationTools: false },
        );

        // Calculate zoom level dynamically based on screen width
        // const getDynamicZoomLevel = () => {
        //   const screenWidth = window.innerWidth;
        //   const baseWidth = 375; // Base width for mobile phones (adjust as needed)
        //   const zoomLevel = (screenWidth / baseWidth) * 100;
        //   return zoomLevel;
        // };

        // Calculate zoom level dynamically based on container width instead of screen width
        // Calculate zoom level dynamically based on container width instead of screen width
        const getDynamicZoomLevel = () => {
          const container = document.getElementById("adobe-dc-view");
          if (container) {
            console.log("container");
            const containerWidth = container.offsetWidth;

            // Adjust base width for different screen sizes
            const baseWidth = 800; // Adjust this value as needed for a more appropriate zoom level

            // Calculate zoom level based on container width
            let zoomLevel = (containerWidth / baseWidth) * 100;
            console.log(zoomLevel);

            // Cap zoom level between a reasonable range (adjust as needed)
            const maxZoom = 150; // Maximum zoom level
            const minZoom = 50; // Minimum zoom level

            if (zoomLevel > maxZoom) zoomLevel = maxZoom;
            if (zoomLevel < minZoom) zoomLevel = minZoom;

            return zoomLevel;
          }
          return 100; // Default zoom level if container not found
        };

        // After the document is loaded, jump to the specified page
        previewFilePromise.then((adobeViewer) => {
          adobeViewer.getAPIs().then((apis) => {
            apis.gotoLocation(pageNumber); // Jump to the desired page
            // const zoomLevel = getDynamicZoomLevel();
            // const zoomApis = apis.getZoomAPIs();
            // zoomApis.setZoomLevel(zoomLevel); // Set zoom level dynamically
          });
        });
      };

      if (window.AdobeDC) {
        initializeAdobeSDK();
      } else {
        const script = document.createElement("script");
        script.src = "https://documentcloud.adobe.com/view-sdk/main.js";
        script.async = true;

        script.onload = () => {
          let attempts = 0;
          const maxAttempts = 10;

          const attemptInitialization = () => {
            if (window.AdobeDC) {
              initializeAdobeSDK();
            } else if (attempts < maxAttempts) {
              setTimeout(attemptInitialization, 500);
              attempts++;
            } else {
              console.error("AdobeDC did not load properly.");
            }
          };

          attemptInitialization();
        };

        document.body.appendChild(script);
        return () => document.body.removeChild(script);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return <div id="adobe-dc-view" className="" />;
};

export default AdobeViewer;
